import { render, staticRenderFns } from "./ContentPageView.vue?vue&type=template&id=0fa3f122"
import script from "./ContentPageView.vue?vue&type=script&lang=js"
export * from "./ContentPageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports